import { isWeb } from "@tamagui/core";
import { colors } from "../../config/colors.mjs";
const sizeTokens = {
    "textInput.height": isWeb ? 40 : 48
  },
  spaceTokens = {
    "textInput.borderWidth": 1,
    "textInput.horizontalPadding": isWeb ? 12 : 16
  },
  radiusTokens = {
    textInput: 6
  },
  colorTokens = {
    "textInput.background": colors.white,
    "textInput.background.disabled": colors["grey.100"],
    "textInput.border.default": colors["grey.400"],
    "textInput.border.default.focus": colors["grey.800"],
    "textInput.border.default.hover": colors["grey.800"],
    "textInput.border.disabled": colors["grey.400"],
    "textInput.border.error": colors["red.600"],
    "textInput.shadow.default": colors["grey.400"],
    "textInput.shadow.error": colors["red.300"]
  };
export { colorTokens, radiusTokens, sizeTokens, spaceTokens };
//# sourceMappingURL=TextInput.tokens.mjs.map
